import { AccessType } from 'app/auth/accessControlService'
import TopicsPage from '../TopicsPage'
import Topics from '../Topics'
import TopicsDetails from '../TopicsDetails'
import { Routes } from 'app/services/routeService/routeService'

export const TopicsConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: true,
        },
        toolbar: {
          display: true,
        },
        leftSidePanel: {
          display: true,
        },
      },
    },
  },
  routes: [
    {
      path: Routes.topics(),
      component: TopicsPage,
      accesses: [
        AccessType.NOTIFICATION_VIEW_OWNED,
        AccessType.NOTIFICATION_SEND,
        AccessType.ADMINISTRATION,
      ],
      routes: [
        {
          exact: true,
          path: Routes.topics(),
          component: Topics,
        },
        {
          exact: true,
          path: Routes.topicDetail(),
          component: TopicsDetails,
        },
      ],
    },
  ],
}
